import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "changelog-item__header" }
const _hoisted_2 = { class: "changelog-item__date" }
const _hoisted_3 = {
  key: 0,
  class: "changelog-item__read"
}
const _hoisted_4 = { class: "changelog-item__content" }
const _hoisted_5 = { class: "changelog-item__title" }
const _hoisted_6 = ["innerHTML"]

import { computed } from 'vue'
import { Changelog } from '@/models/interfaces'
import * as Mixpanel from '@/analytics/mixpanel/mixpanel'


export default /*@__PURE__*/_defineComponent({
  __name: 'Item',
  props: {
    item: {},
    isDetail: { type: Boolean },
    onBack: { type: Function }
  },
  setup(__props: any) {

const props = __props

const handleLinkClick = (event: MouseEvent): void => {
  const target = event.target as HTMLElement
  if (target.tagName === 'A') {
    event.preventDefault()
    const href = target.getAttribute('href')
    if (href) {
      Mixpanel.trackChangelogLinkClick(href)
      window.open(href, '_blank', 'noopener,noreferrer')
    }
  }
}

const formattedDate = computed(() => {
  return new Date(props.item.change_date).toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["changelog-item", { 'changelog-item__detail': __props.isDetail }])
  }, [
    (__props.isDetail && __props.onBack)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "changelog-item__back",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onBack && __props.onBack(...args)))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "back-link__icon iconfont iback" }, null, -1),
          _createElementVNode("span", { class: "back-link__text changelog-item__back-text" }, "Back", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(formattedDate.value), 1),
      (!__props.item.is_historical && !__props.item.is_read && !__props.isDetail)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Unread "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h4", _hoisted_5, _toDisplayString(__props.item.title), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["changelog-item__text", { 'changelog-item__text--cropped': !__props.isDetail }]),
        onClick: handleLinkClick,
        innerHTML: __props.isDetail ? __props.item.text : __props.item.blurb
      }, null, 10, _hoisted_6)
    ])
  ], 2))
}
}

})